import React from 'react';
import { RouteNavigation } from './index';

const Home: React.FC = () => {
  return (
    <div>
      <h1>Visualisation Tools</h1>
      <p>This is a collection of visualisations for the wiki @ <a href="https://www.abhinandshibu.com">abhinandshibu.com</a></p>
      <RouteNavigation />
    </div>
  );
};

export default Home;
